"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _commonComponents = require("../commonComponents");
var _utils = require("./utils");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _deleteButton = _interopRequireDefault(require("./buttons/deleteButton"));
var _fieldOld = _interopRequireDefault(require("../fieldOld"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _interfaceTransformer = _interopRequireDefault(require("../interfaceTransformer"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _excluded = ["interface"],
  _excluded2 = ["onClick", "disable", "addButtonLabel", "addRowButton"],
  _excluded3 = ["items", "fields", "meta", "required", "movable", "stateFromRedux", "form", "nowDate", "components", "moveUpButtonLabel", "moveDownButtonLabel", "deleteButtonIcon", "className", "draggable", "draggableIcon", "emptyAddRow", "limitLength", "isOrdered"],
  _excluded4 = ["component", "interface", "className", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ArrayTypes = ['flatarray', 'array'];

// preparing field form object for duplication
var prepareFields = function prepareFields(items) {
  return _lodash["default"].reduce(items, function (acc, item) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, item.name, _lodash["default"].includes(ArrayTypes, item["interface"]) ? [] : ''));
  }, {});
};
var getIsRequiredChild = function getIsRequiredChild(_ref, parentRequired) {
  var intf_origin = _ref["interface"],
    restItem = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var intf = (0, _interfaceTransformer["default"])(intf_origin);
  if (intf === 'checkbox') {
    if (!restItem.required && !_lodash["default"].has(restItem, 'options')) {
      return false;
    }
  }

  // fields that do not have 'inputs' will not validate
  // for example, paragraphs, labels, etc.
  // so no need to check for those here

  return parentRequired;
};
var grid = 8;
var getItemStyle = function getItemStyle(isDragging, draggableStyle) {
  return _objectSpread({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: "0 0 ".concat(grid, "px 0")
  }, draggableStyle);
};
var draggableEvent = function draggableEvent(_ref2, _ref3) {
  var source = _ref2.source,
    destination = _ref2.destination;
  var move = _ref3.move;
  // short circuit if either values are null
  // this can happen if you attempt to drop to a different droppable destination
  if (_lodash["default"].isNull(source.droppableId)) return;
  if (_lodash["default"].isNull(destination)) return;
  if (_lodash["default"].isNull(destination.droppableId)) return;

  //making sure the droppable source and destination are the same
  if (_lodash["default"].isEqual(source.droppableId, destination.droppableId)) {
    // only calling swap if the index is different
    if (!_lodash["default"].isEqual(source.index, destination.index)) {
      move(source.index, destination.index);
    }
  }
};
var CustomAddButton = function CustomAddButton(_ref4) {
  var onClick = _ref4.onClick,
    disable = _ref4.disable,
    addButtonLabel = _ref4.addButtonLabel,
    CustomAdd = _ref4.addRowButton,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  if (!_lodash["default"].isUndefined(CustomAdd)) {
    return /*#__PURE__*/_react["default"].createElement(CustomAdd, {
      className: "add_row",
      onClick: onClick,
      id: "t-add_row_button-".concat(rest.config.name),
      disabled: disable
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_commonComponents.AddButton, {
    className: "add_row",
    onClick: onClick,
    buttonStyle: "confirm",
    id: "t-add_row_button-".concat(rest.config.name),
    disabled: disable
  }, addButtonLabel);
};

//
// Render Array
//
var RenderArray = function RenderArray(props) {
  var items = props.items,
    fields = props.fields,
    error = props.meta.error,
    required = props.required,
    movable = props.movable,
    stateFromRedux = props.stateFromRedux,
    form = props.form,
    nowDate = props.nowDate,
    components = props.components,
    moveUpButtonLabel = props.moveUpButtonLabel,
    moveDownButtonLabel = props.moveDownButtonLabel,
    deleteButtonIcon = props.deleteButtonIcon,
    className = props.className,
    draggable = props.draggable,
    draggableIcon = props.draggableIcon,
    EmptyAddRow = props.emptyAddRow,
    limitLength = props.limitLength,
    _props$isOrdered = props.isOrdered,
    isOrdered = _props$isOrdered === void 0 ? false : _props$isOrdered,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var preparedFields = prepareFields(items);
  var _rest$config$disabled = rest.config.disabled,
    disabled = _rest$config$disabled === void 0 ? false : _rest$config$disabled;
  var disableAddButton = !_lodash["default"].isUndefined(limitLength) ? fields.length < limitLength : true;
  if (!_lodash["default"].isUndefined(EmptyAddRow) && fields.length === 0) {
    // only display
    return /*#__PURE__*/_react["default"].createElement(EmptyAddRow, {
      onClick: function onClick() {
        return fields.push(preparedFields);
      },
      id: "t-add_row_button-".concat(rest.config.name),
      disabled: disabled
    });
  }
  var handleAddPage = function handleAddPage() {
    // Add unique identifier if the isOrdered flag is set to true
    var addId = isOrdered ? {
      identifier: (0, _uniqid["default"])()
    } : {};
    fields.push(_objectSpread(_objectSpread({}, preparedFields), addId));
  };
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: function onDragEnd(d) {
      return draggableEvent(d, fields);
    }
  }, /*#__PURE__*/_react["default"].createElement(_commonComponents.OuterUl, {
    className: "array"
  }, /*#__PURE__*/_react["default"].createElement(_commonComponents.Li, null, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    isDropDisabled: !draggable,
    droppableId: "droppable_".concat(fields.name)
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerUl, {
      ref: provided.innerRef,
      className: "".concat(snapshot.isDraggingOver ? 'draggingOver' : '')
    }, fields.map(function (fieldItem, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        key: "".concat(fields.name, "_field_item_").concat(fieldItem),
        draggableId: "".concat(fields.name, "_field_item_").concat(fieldItem),
        index: index
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
          ref: provided.innerRef
        }, provided.draggableProps, {
          className: "".concat(snapshot.isDragging ? 'isDragging' : '', " row").concat(!_lodash["default"].isUndefined(className) ? " ".concat(className) : ''),
          style: getItemStyle(snapshot.isDragging, provided.draggableProps.style)
        }), /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerUl, null, /*#__PURE__*/_react["default"].createElement("li", {
          className: "delete"
        }, /*#__PURE__*/_react["default"].createElement(_deleteButton["default"], {
          type: "button",
          className: "delete_row",
          onClick: function onClick() {
            return fields.remove(index);
          },
          id: "t-".concat(rest.config.name, "-").concat(index, "-delete"),
          deleteButtonIcon: deleteButtonIcon,
          disabled: disabled
        })), _lodash["default"].map(items, function (item) {
          var component = item.component,
            intf_origin = item["interface"],
            _item$className = item.className,
            className = _item$className === void 0 ? undefined : _item$className,
            _item$disabled = item.disabled,
            itemDisabled = _item$disabled === void 0 ? undefined : _item$disabled,
            restItem = (0, _objectWithoutProperties2["default"])(item, _excluded4);
          var key = "".concat(fieldItem, ".").concat(restItem.name);
          var intf = (0, _interfaceTransformer["default"])(intf_origin);
          restItem['id'] = "t-".concat(rest.config.name, "-").concat(restItem.name, "-").concat(index);

          // need to determine if the parent is require, similarly the children should be
          // as well, in some cases single checkbox fields are not necessarily required
          var required_child = getIsRequiredChild(item, required);
          var config = _lodash["default"].omit(_objectSpread(_objectSpread({}, restItem.config), {}, {
            required: required_child
          }), ['movable', 'name', 'items']);
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: "".concat(fields.name, "_field_item_").concat(fieldItem).concat(key),
            className: "".concat(!_lodash["default"].isUndefined(className) ? className : '')
          }, /*#__PURE__*/_react["default"].createElement(_fieldOld["default"], (0, _extends2["default"])({
            "interface": intf
          }, restItem, {
            components: components,
            form: form,
            config: config,
            key: key,
            name: key,
            nowDate: nowDate,
            disabled: itemDisabled !== null && itemDisabled !== void 0 ? itemDisabled : disabled
          })));
        }), /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
          className: "draggable ".concat(draggable ? 'isDraggable' : '')
        }, provided.dragHandleProps), draggableIcon), movable && /*#__PURE__*/_react["default"].createElement("li", {
          className: "movable"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "move_up",
          onClick: function onClick(e) {
            return (0, _utils.ArrayMoveUp)(e, index, fields);
          },
          disabled: disabled
        }, moveUpButtonLabel), /*#__PURE__*/_react["default"].createElement("button", {
          className: "move_down",
          onClick: function onClick(e) {
            return (0, _utils.ArrayMoveDown)(e, index, fields);
          },
          disabled: disabled
        }, moveDownButtonLabel))));
      });
    }));
  }), error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), /*#__PURE__*/_react["default"].createElement(CustomAddButton, (0, _extends2["default"])({
    onClick: handleAddPage,
    disable: disabled || !disableAddButton
  }, rest)))));
};
RenderArray.handlesErrorDisplay = true;
RenderArray.defaultProps = {
  draggableIcon: '☰',
  draggable: false,
  movable: false,
  addButtonLabel: '+ Add Row',
  moveUpButtonLabel: 'Move Up',
  moveDownButtonLabel: 'Move Down',
  deleteButtonIcon: '✖',
  className: undefined,
  emptyAddRow: undefined,
  addRowButton: undefined
};
var _default = exports["default"] = RenderArray;